import styled from 'styled-components'

const Navigation = styled.nav`
  counter-reset: dot;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-wrap: wrap;
`

export default Navigation
